/**
 * Useful for crawling the hierarchy
 * @param hierarchy
 * @param cb
 */
export function traverse(hierarchy: Hierarchy.IHierarchyItem[], cb: (item: Hierarchy.IHierarchyItem) => void) {
    let walk = (items: Hierarchy.IHierarchyItem[]) => {
        if (!items) {
            return;
        }

        items.forEach(item => {
            cb(item);
            walk(item.children);
        });
    };

    walk(hierarchy);
}
